<template>
  <v-app id="inspire">
    <v-progress-linear
      v-show="loading"
      color="accent"
      class="progress-bar-small"
      height="4"
      background-color="red lighten-3"
      indeterminate
    />

    <ConfirmDialog
      :is-open="confirmDialog.isOpen"
      :title="confirmDialog.title"
      :body="confirmDialog.body"
      :cancel-text="confirmDialog.cancelText"
      :confirm-text="confirmDialog.confirmText"
    />

    <Snackbar
      :is-open="snackbar.isOpen"
      :text="snackbar.text"
      :link="snackbar.link"
      :action="snackbar.action"
      :timeout="snackbar.timeout"
    />

    <v-content>
      <v-card class="content-wrapper-card">
        <template v-if="showHeader">
          <div class="header-wrapper">
            <img src="./assets/cramo-logo.svg" class="mr-3" height="28" alt="logo" />
            <div>{{ $t('register') }}</div>
          </div>

          <p class="registration-requirements">
            {{ $t('registration_confirmation_requirements') }}
            <a
              href="https://www.smart-id.com/lt/pagalba/duk/registracija/smart-id-registracijos-budai/"
              target="_blank"
            >
              {{ $t('smart_id_link') }}
            </a>
          </p>
        </template>

        <v-fade-transition mode="out-in">
          <router-view :key="$route.fullPath" />
        </v-fade-transition>
      </v-card>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ConfirmDialog from './components/ConfirmDialog.vue';
import Snackbar from './components/Snackbar.vue';
import { getLocalStorageItem } from '@/util/local-storage';

export default {
  components: {
    ConfirmDialog,
    Snackbar,
  },

  data() {
    return {
      isOpen: false,
    };
  },

  computed: {
    ...mapState({
      confirmDialog: (state) => state.ui.confirmDialog,
      snackbar: (state) => state.ui.snackbar,
      loading: (state) => state.ui.loading,
      isTouchDevice: (state) => state.settings.isTouchDevice,
    }),

    showHeader() {
      return this.$route.name && this.$route.fullPath.indexOf('sign-document') === -1;
    },
  },

  created() {
    this.addTouchListener();
    let settings = getLocalStorageItem('settings');
    if (settings) {
      settings = JSON.parse(settings);
      this.storeSettings(settings);
      if (settings.locale) {
        this.$i18n.locale = settings.locale;
      }
    }
  },

  methods: {
    ...mapMutations({
      setTouchDevice: 'settings/setTouchDevice',
      storeSettings: 'settings/store',
    }),

    addTouchListener() {
      window.addEventListener('touchstart', () => {
        if (!this.isTouchDevice) {
          this.setTouchDevice();
        }
      });
    },
  },
};
</script>

<style>
.v-content {
  background: #f0f0f0;
}

.application {
  font-family: 'Segoe UI', sans-serif;
}

.v-messages {
  bottom: 1px; /* fixes error messages for Segoe UI font */
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.content-wrapper-card {
  max-width: 910px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
}

.header-wrapper {
  width: 100%;
  text-align: center;
  padding-top: 30px;
  font-size: 28px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.registration-requirements {
  text-align: center;
  font-size: 18px;
}

.primary-btn {
  margin: 12px 0;
  min-width: 120px;
  float: right;
}

.form-wrapper {
  background: #f3f3f3;
  padding: 12px;
}

.wrapper {
  padding: 0 36px;
}

.v-text-field {
  padding: 12px 2px 6px 2px;
}

.theme--light.application {
  background: #fff;
}

.v-navigation-drawer__border {
  display: none;
}

.container.fill-height {
  align-items: unset;
}

.alert-text {
  color: #ff5252 !important;
  font-weight: bold !important;
}

.success-text {
  color: #4caf50 !important;
  font-weight: bold !important;
}

.clickable {
  cursor: pointer !important;
}

.clickable .v-chip__content {
  cursor: pointer !important;
}

.default-cursor {
  cursor: default !important;
}

.row-actions {
  position: absolute;
  right: 0;
  padding: 0 12px !important;
  background: inherit;
  display: none;
  z-index: 2;
}

.table-row {
  position: relative;
}

.table-row:hover .row-actions {
  display: flex;
}

.progress-bar-small {
  position: fixed !important;
  z-index: 4;
  margin: 0;
}

.bottom-margin {
  margin-bottom: 90px;
}

.full-width {
  width: 100%;
  padding-bottom: 85px;
}

.v-form > .container {
  padding: 8px;
}

td:first-child:not(.v-datatable__expand-col),
th:first-child {
  padding: 0 12px !important;
}

td.text-xs-right,
th.text-xs-right {
  padding: 0 12px 0 0 !important;
}

.row-detail-wrapper {
  padding: 12px;
  background: #eeeeee;
}

.actions-column {
  padding: 0 8px !important;
  text-align: right;
  white-space: nowrap;
}

.v-list__tile--active {
  background: rgba(176, 28, 0, 0.12);
}

.theme--light.v-btn.v-btn--icon .v-icon {
  color: #b01c00;
}

.theme--light.v-btn.v-btn--icon .v-icon:hover {
  color: black;
}

.v-input--selection-controls.v-input .v-label {
  font-size: 12px;
  color: black;
}

/* required element to pass in googleMaps PlacesService constructor */
/* google-maps-places-mixin.js */
#map-container {
  display: none !important;
}

.message-div {
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6rem;
  text-align: center;
  height: 75%;
}

.floating-message {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 50;
}

.position-relative {
  position: relative;
}

@media only screen and (max-width: 700px) {
  .header-wrapper {
    display: block;
  }

  .wrapper {
    padding: 0 12px;
  }
}
</style>
